import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const scrollMap = new Map();

export function ScrollRestoration() {
    const location = useLocation();
    const navType = useNavigationType();
    const key = location.pathname + location.search;

    const latestScrollY = useRef(0);

    // Track window scroll safely
    useEffect(() => {
        const onScroll = () => {
            latestScrollY.current = window.scrollY;
        };

        // Use passive listener to ensure no main thread blocking
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    // Restore on navigation
    useEffect(() => {
        if (navType === 'POP' && scrollMap.has(key)) {
            window.scrollTo(0, scrollMap.get(key));
        } else {
            window.scrollTo(0, 0);
        }

        // Save position ONLY on route change (cleanup)
        return () => {
            scrollMap.set(key, latestScrollY.current);
        };
    }, [key, navType]);

    return null;
}

/**
 * CLEANUP LEGACY HELPERS
 * These are simplified to use window scroll only and avoid unstable container logic.
 */
export const scrollToTop = () => {
    window.scrollTo(0, 0);
};

export const scrollToTopImmediate = () => {
    window.scrollTo(0, 0);
};

export const useScrollRestoration = () => {
    return { scrollToTopOnRouteChange: () => window.scrollTo(0, 0) };
};

export const handlePageChangeWithScroll = (setCurrentPage, newPage) => {
    setCurrentPage(newPage);
    window.scrollTo(0, 0);
};

export const navigateWithScrollReset = (navigate, path, contentRef, state = null) => {
    window.scrollTo(0, 0);
    if (state) {
        navigate(path, { state });
    } else {
        navigate(path);
    }
};
